import { FormatOptionLabelMeta } from 'react-select';

import ControlPanelContainer from 'dashboard/apps/DashboardLayoutEditor/ControlPanel/ControlPanelContainer';
import ReactSelect, { OptionType } from 'dashboard/components/ReactSelect';
import { ModuleInput } from 'dashboard/modules/Input';
import Input from 'design-system/components/Input';
import Spacer from 'design-system/components/Spacer';
import { Heading, Label, Paragraph } from 'design-system/components/Text';
import { FIELD_SCHEMA_TYPE_DISPLAY, FieldSchema, FieldSchemaType } from 'lib/fields';

const ALLOWED_FIELD_SCHEMA_TYPES = [
  FieldSchemaType.String,
  FieldSchemaType.Integer,
  FieldSchemaType.Number,
  FieldSchemaType.Date,
];

export interface InputPanelProps {
  module: ModuleInput;
  fieldSchema: FieldSchema[];
  updateModule: (module: ModuleInput) => void;
}

const InputPanel = ({ module, fieldSchema, updateModule }: InputPanelProps) => {
  const allowedFields = fieldSchema.filter((f) => ALLOWED_FIELD_SCHEMA_TYPES.includes(f.type));
  const options = allowedFields.map((f) => {
    const dasherizedKey = f.key.split('_').join('-');
    return {
      label: f.key,
      value: dasherizedKey,
      fieldType: f.type,
    };
  });

  const handleUpdateFieldKey = (fieldKey: string) => {
    const dasherizedKey = fieldKey.split('_').join('-');
    const label = fieldSchema.find((fs) => fs.key === dasherizedKey)?.label ?? '';
    updateModule({
      ...module,
      label: label,
      'field-key': dasherizedKey,
    });
  };

  const handleUpdateLabel = (label: string) => {
    updateModule({
      ...module,
      label: label,
    });
  };

  return (
    <ControlPanelContainer>
      <Heading size='sm'>Settings</Heading>
      <Spacer height={2} />
      <Label size='md' weight='bold'>
        Field key
      </Label>
      <ReactSelect<string, OptionType<string> & { fieldType: FieldSchemaType; label: string }>
        id='input-panel__field-key-selector'
        aria-labelledby='input-panel__selector-label'
        options={options}
        value={module['field-key']}
        onChange={handleUpdateFieldKey}
        formatOptionLabel={formatFieldKeyOption}
        portal
      />
      <Spacer height={2} />
      <Label size='md' weight='bold'>
        Label
      </Label>
      <Input
        type='text'
        onChange={(e) => handleUpdateLabel(e.target.value)}
        value={module['label']}
      />
    </ControlPanelContainer>
  );
};

const formatFieldKeyOption = (
  { fieldType, label }: { fieldType: FieldSchemaType; label: string; value: string },
  {
    context,
  }: FormatOptionLabelMeta<OptionType<string> & { fieldType: FieldSchemaType; label: string }>,
) => {
  const selectionText = `Type: ${
    FIELD_SCHEMA_TYPE_DISPLAY[fieldType as FieldSchemaType] || 'Unknown'
  }`;
  if (context === 'menu') {
    return (
      <div>
        <Paragraph style={{ lineBreak: 'anywhere' }}>{label}</Paragraph>
        <Paragraph size='sm'>{selectionText}</Paragraph>
      </div>
    );
  } else {
    return label;
  }
};

export default InputPanel;
